<template>
  <div>
    <login-after-head></login-after-head>
    <head-nav-bar isIndexPage></head-nav-bar>
    <div class="index-banner" id="jumbotron">
      <!-- banner 右侧上面的信息 -->
      <index-banner-right></index-banner-right>
      <!-- banner 轮播 -->
      <index-banner></index-banner>

    </div>
    <div class="index-main pr">


      <!-- ad -->
      <!--		<div class="container img-link-bar">-->
      <!--			<a href="">-->
      <!--				<img src="../assets/300.png" alt="">-->
      <!--			</a>-->
      <!--		</div>-->
      <!-- 6个楼层 -->
      <div class="index-floor-item container one-floor" id="floor1">
        <div class="one-floor-top fc">
          <div class="top-left">
            <span class="left-text ">1F 新产品</span>
          </div>
        </div>
        <div class="one-floor-main flex">

          <div class="left-left">
            <router-link :to="{path:'/list',query:{productId:99814}}" class="a">
              <img class="bgf" src="https://zxapi.tengen.com.cn/appStatic/floor_1.png">
            </router-link>
            <!--            <div class="dl-first-box">-->
            <!--              <div class="dl-two-box dis f14 dl-small-box">-->
            <!--                <router-link to="list" class="dl-two">-->
            <!--                  自恢复式欠压保护器-->
            <!--                </router-link>-->
            <!--              </div>-->
            <!--              <ul class="dl-three-box">-->
            <!--                <li v-for="(item,index) in 10" :key="index">-->
            <!--                  <router-link to="list">电涌保护器</router-link>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->

          </div>
          <div class="right-right flex1">
            <div class="product-item" v-for="(item,index) in floorProductListOne" :key="index">
              <router-link :to="{path:'/list',query:{productId:item.id}}">
                <img :src="item.image" alt="">
                <h4>{{item.storeName}}</h4>
<!--                <p>abc-001</p>-->
              </router-link>
            </div>
          </div>


        </div>
      </div>

      <div class="index-floor-item container one-floor" id="floor2">
        <div class="one-floor-top fc">
          <div class="top-left">
            <span class="left-text ">2F 热搜系列</span>
          </div>
        </div>
        <div class="one-floor-main flex">

          <div class="left-left">
            <router-link :to="{path:'/list',query:{productId:124844}}" class="a">
              <img class="bgf" src="https://zxapi.tengen.com.cn/appStatic/floor_2.png">
            </router-link>
            <!--            <div class="dl-first-box">-->
            <!--              <div class="dl-two-box dis f14 dl-small-box">-->
            <!--                <router-link to="list" class="dl-two">低压配电系列</router-link>-->
            <!--              </div>-->
            <!--              <ul class="dl-three-box">-->
            <!--                <li v-for="(item,index) in 10" :key="index">-->
            <!--                  <router-link to="list">CDM3E电子式塑壳</router-link>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->

          </div>
          <div class="right-right flex1">
            <div class="product-item" v-for="(item,index) in floorProductListTwo" :key="index">
              <router-link :to="{path:'/list',query:{productId:item.id}}">
                <img :src="item.image" alt="">
                <h4>{{item.storeName}}</h4>
<!--                <p>abc-001</p>-->
              </router-link>
            </div>
          </div>


        </div>
      </div>

      <div class="index-floor-item container one-floor" id="floor3">
        <div class="one-floor-top fc">
          <div class="top-left">
            <span class="left-text ">3F 精品热推</span>
          </div>
        </div>
        <div class="one-floor-main flex">

          <div class="left-left">
            <router-link :to="{path:'/list',query:{productId:53819}}" class="a">
              <img class="bgf" src="https://zxapi.tengen.com.cn/appStatic/floor_3.png">
            </router-link>
            <!--            <div class="dl-first-box">-->
            <!--              <div class="dl-two-box dis f14 dl-small-box">-->
            <!--                <router-link to="list" class="dl-two">低压配电系列</router-link>-->
            <!--              </div>-->
            <!--              <ul class="dl-three-box">-->
            <!--                <li v-for="(item,index) in 10" :key="index">-->
            <!--                  <router-link to="list">CDM3E电子式塑壳</router-link>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->

          </div>
          <div class="right-right flex1">
            <div class="product-item" v-for="(item,index) in floorProductListThree" :key="index">
              <router-link :to="{path:'/list',query:{productId:item.id}}">
                <img :src="item.image" alt="">
                <h4>{{item.storeName}}</h4>
<!--                <p>abc-001</p>-->
              </router-link>
            </div>
          </div>


        </div>
      </div>

      <!--      <div class="index-floor-item container one-floor" id="floor4">-->
      <!--        <div class="one-floor-top fc">-->
      <!--          <div class="top-left">-->
      <!--            <span class="left-text ">4F 仪器仪表</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="one-floor-main flex">-->

      <!--          <div class="left-left">-->
      <!--            <router-link to="list" class="a">-->
      <!--              <img class="bgf" src="../assets/cp/chanping5.png">-->
      <!--            </router-link>-->
      <!--            <div class="dl-first-box">-->
      <!--              <div class="dl-two-box dis f14 dl-small-box">-->
      <!--                <router-link to="list" class="dl-two">低压配电系列</router-link>-->
      <!--              </div>-->
      <!--              <ul class="dl-three-box">-->
      <!--                <li v-for="(item,index) in 10" :key="index">-->
      <!--                  <router-link to="list">CDM3E电子式塑壳</router-link>-->
      <!--                </li>-->
      <!--              </ul>-->
      <!--            </div>-->

      <!--          </div>-->
      <!--          <div class="right-right flex1">-->
      <!--            <div class="product-item" v-for="(item,index) in 8" :key="index">-->
      <!--              <router-link to="details">-->
      <!--                <img src="https://dmc.tengen.com.cn/xweb/api/v1/dms/commonAttachUpload/getFile?id=22351" alt="">-->
      <!--              </router-link>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="index-floor-item container one-floor" id="floor5">-->
      <!--        <div class="one-floor-top fc">-->
      <!--          <div class="top-left">-->
      <!--            <span class="left-text ">5F 电能管理</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="one-floor-main flex">-->

      <!--          <div class="left-left">-->
      <!--            <router-link to="list" class="a">-->
      <!--              <img class="bgf" src="../assets/cp/chanping5.png">-->
      <!--            </router-link>-->
      <!--            <div class="dl-first-box">-->
      <!--              <div class="dl-two-box dis f14 dl-small-box">-->
      <!--                <router-link to="list" class="dl-two">低压配电系列</router-link>-->
      <!--              </div>-->
      <!--              <ul class="dl-three-box">-->
      <!--                <li v-for="(item,index) in 10" :key="index">-->
      <!--                  <router-link to="list">CDM3E电子式塑壳</router-link>-->
      <!--                </li>-->
      <!--              </ul>-->
      <!--            </div>-->

      <!--          </div>-->
      <!--          <div class="right-right flex1">-->
      <!--            <div class="product-item" v-for="(item,index) in 8" :key="index">-->
      <!--              <router-link to="details">-->
      <!--                <img src="https://dmc.tengen.com.cn/xweb/api/v1/dms/commonAttachUpload/getFile?id=22351" alt="">-->
      <!--              </router-link>-->
      <!--            </div>-->
      <!--          </div>-->


      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="index-floor-item container one-floor" id="floor6">-->
      <!--        <div class="one-floor-top fc">-->
      <!--          <div class="top-left">-->
      <!--            <span class="left-text ">6F 电气辅材</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="one-floor-main flex">-->

      <!--          <div class="left-left">-->
      <!--            <router-link to="list" class="a">-->
      <!--              <img class="bgf" src="../assets/cp/chanping5.png">-->
      <!--            </router-link>-->
      <!--            <div class="dl-first-box">-->
      <!--              <div class="dl-two-box dis f14 dl-small-box">-->
      <!--                <router-link to="list" class="dl-two">低压配电系列</router-link>-->
      <!--              </div>-->
      <!--              <ul class="dl-three-box">-->
      <!--                <li v-for="(item,index) in 10" :key="index">-->
      <!--                  <router-link to="list">CDM3E电子式塑壳</router-link>-->
      <!--                </li>-->
      <!--              </ul>-->
      <!--            </div>-->

      <!--          </div>-->
      <!--          <div class="right-right flex1">-->
      <!--            <div class="product-item" v-for="(item,index) in 8" :key="index">-->
      <!--              <router-link to="details">-->
      <!--                <img src="https://dmc.tengen.com.cn/xweb/api/v1/dms/commonAttachUpload/getFile?id=22351" alt="">-->
      <!--              </router-link>-->
      <!--            </div>-->
      <!--          </div>-->


      <!--        </div>-->
      <!--      </div>-->

      <div class="floor-list" :class="{fixedFloor:fixedFloor}">
        <a href="" @click.prevent="toLift('floor1')">新产品</a>
        <a href="" @click.prevent="toLift('floor2')">热搜系列</a>
        <a href="" @click.prevent="toLift('floor3')">精品热推</a>
        <!--        <a href="" @click.prevent="toLift('floor4')">仪器仪表</a>-->
        <!--        <a href="" @click.prevent="toLift('floor5')">电能管理</a>-->
        <!--        <a href="" @click.prevent="toLift('floor6')">电气辅材</a>-->
        <a class="goTopImg-box" @click.prevent="toTop()"><i class="goTopImg"></i></a>
      </div>

    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import {getCategory} from "@/api/indexpage";
import {floorProduct, queryCategoryList, checkShowKefu, closeKefu} from "@/api/home";

export default {

  data() {
    return {
      fixedFloor: false,
      orderCount: null,
      queryParams: {},
      categoryList: [],
      floorProductListOne:[],
      floorProductListTwo:[],
      floorProductListThree:[],

    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    //缓存处理
    let sessCategorys = JSON.parse(sessionStorage.getItem('categorys'))
    console.log('缓存分类：',sessCategorys)
    if (sessCategorys && sessCategorys.length>0){
      this.categoryList = sessCategorys
    }else{
      this.queryCategoryListFun()
    }
    this.floorProduct();
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    //console.log("detail userInfo.uid",userInfo);
    if (userInfo && userInfo.name){
      this.checkShowKefu();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true)
  },
  methods: {
    checkShowKefu(){
      checkShowKefu().then(res=>{
        console.log('是否显示客服：',res.data)
        if(res.data){
          closeKefu().then(res=>{
            this.$router.push({path:'/kefu'})
          })
        }
      })
    },
    floorProduct() {
      var ids= [1, 2,3];
      floorProduct(ids).then(res => {
        console.log('查询到首页楼层的产品', res)
        for (let item of res.data) {
          //console.log('开始循环', item)
          if(item.floor===1){
            this.floorProductListOne.push(item)
          }
          if(item.floor===2){
            this.floorProductListTwo.push(item)
          }
          if(item.floor===3){
            this.floorProductListThree.push(item)
          }
        }
      })
    },
    queryCategoryListFun() {
      queryCategoryList().then(res => {
        console.log('查询分类', res)
        this.categoryList = res.categorys
        sessionStorage.setItem('categorys', JSON.stringify(res.categorys))
      })
    },
    handleScroll() {
      const floor1 = document.getElementById("floor1")
      if (!floor1) return
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      var fixedNumber = floor1.offsetTop + 71 + 470
      scrolltop > fixedNumber ? (this.fixedFloor = true) : (this.fixedFloor = false);
    },
    toTop(i) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    toLift(id) {
      const el = document.getElementById(id)
      if (!el) return
      var parentTop = el.offsetTop + 71 + 470
      window.scrollTo({
        top: parentTop,
        left: 0,
        behavior: "smooth"
      });


    }
  },


}
</script>

<style scoped>
.index-main {
  background: #F2F2F2;
}
</style>
